import actionCreator from "helpers/actionCreator"
import { handleSetPage } from "helpers/compositeSecuritiesDetails"

export const { Types, Creators } = actionCreator("ompnt/modules/analyzeCompositeBetaContributors", {
  setPage: ["page"],
})

export const queryStringReducers = {
  [Types.SET_PAGE]: handleSetPage,
}
